exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appFooter[data-v-478cce1c]{background-color:#f6f6f6;color:#838383}.footer-content[data-v-478cce1c]{display:flex;justify-content:space-evenly;max-width:844px;margin:0 auto 2rem;text-align:left}@media(max-width: 768px){.footer-content[data-v-478cce1c]{display:block;text-align:center}}.small-title[data-v-478cce1c]{font-weight:800;text-transform:uppercase}.footer-content-column[data-v-478cce1c]{max-width:480px;margin-right:60px}@media(max-width: 768px){.footer-content-column[data-v-478cce1c]{margin-right:0;margin-bottom:1.5rem;max-width:initial}}.large-text[data-v-478cce1c]{font-size:24px}", ""]);

// exports
